import React from 'react';
import {GeneratedVideoChunk} from '../../../data/models/LibraryFile/GeneratedVideoChunk';
import {EditChunkOption} from '../../../data/repositories/LibraryRepository';
import {DraggableChunks} from './DraggableChunks';
interface Props {
  chunks: GeneratedVideoChunk[];
  lockedChunkIds?: Set<string>;
  selectedChunk?: GeneratedVideoChunk;
  onEditChunk: (option: EditChunkOption, chunkId: string) => void;
  onSelectChunk: (chunk: GeneratedVideoChunk) => void;
  onAddFromLibrary: () => void;
  onAddFromStoryblocks: () => void;
  addDisabled?: boolean;
  hideChunkDelete?: boolean;
  newChunkIds?: Set<string>;
  totalTimelineSeconds: number;
  pixelsPerSecond: number;
  onChunksReorder: (
    chunks: GeneratedVideoChunk[],
    activeChunkId: string,
    newIndex: number,
  ) => void;
}

const ChunkList: React.FC<Props> = ({
  chunks,
  lockedChunkIds,
  selectedChunk,
  onEditChunk,
  onSelectChunk,
  onAddFromLibrary,
  onAddFromStoryblocks,
  addDisabled,
  hideChunkDelete,
  newChunkIds,
  totalTimelineSeconds,
  pixelsPerSecond,
  onChunksReorder,
}) => {
  return (
    <DraggableChunks
      chunks={chunks}
      lockedChunkIds={lockedChunkIds}
      selectedChunk={selectedChunk}
      onEditChunk={onEditChunk}
      onSelectChunk={onSelectChunk}
      onAddFromLibrary={onAddFromLibrary}
      onAddFromStoryblocks={onAddFromStoryblocks}
      addDisabled={addDisabled}
      hideChunkDelete={hideChunkDelete}
      newChunkIds={newChunkIds}
      onChunksReorder={onChunksReorder}
      totalTimelineSeconds={totalTimelineSeconds}
      pixelsPerSecond={pixelsPerSecond}
    />
  );
};

export default React.memo(ChunkList);
